const PLAN_FEATURES = {
  basic: {
    label: 'Basic',
    features: [
      'GMB sync & reporting',
      'Basic analytics dashboard',
      'Weekly performance emails'
    ]
  },
  advanced: {
    label: 'Advanced',
    features: [
      'All Basic features',
      'Advanced analytics & suggestions',
      'Priority support',
      'Automated posting & scheduling'
    ]
  },
  pro: {
    label: 'Pro',
    features: [
      'All Advanced features',
      'Team management & roles',
      'Custom reporting',
      'Dedicated support'
    ]
  }
};

export default PLAN_FEATURES;
